<mat-form-field appearance="outline" [class]="getPanelClasses()">
  <mat-label>{{ schema.label }}</mat-label>
  <chip-autocomplete-input
    [schema]="schema"
    [required]="schema.required"
    [formGroup]="schema.formGroup"
    [value]="value">
  </chip-autocomplete-input>
  <mat-hint *ngIf="schema.readonly !== false" >{{ schema.hint }}</mat-hint>
</mat-form-field>
